<template>

  <div class="login-page">
    <app-navbar></app-navbar>
    <div class="wrapper wrapper-full-page">
      <div class="full-page login-page section-image">
        <div class="content">
          <div class="container">
            <div class="col-lg-4 col-md-6 ml-auto mr-auto">
              <form @submit.prevent="login">
                <card type="login">
                  <h3 slot="header" class="header text-center">Login</h3>

                  <div v-if="this.loginError" class="bg-red text-center p-2 mt-2 mb-2 text-white" v-html="this.loginError">
                  </div>
                  <template v-if="this.$route.query.msg">
                    <div v-if="this.$route.query.msg == 1" class="bg-warning text-center p-2 mt-2 mb-2 text-white">Logged out</div>
                  </template>

                  <fg-input v-model="form.email" addon-left-icon="nc-icon nc-single-02"
                            placeholder="Email Address" v-validate="'required|email'" name="email"></fg-input>
					        <span class="text-danger">{{ errors.first('email') }}</span>

                  <fg-input v-model="form.password" addon-left-icon="nc-icon nc-key-25" placeholder="Password"
                            type="password" v-validate="'required|min:3'"  name="password"></fg-input>
					        <span class="text-danger">{{ errors.first('password') }}</span>

                  <p-button native-type="submit" type="primary" round block class="my-4">Sign In</p-button>

                  <router-link class="d-block text-center" to="/password-reset">Click Here if you forgot your password</router-link>
                </card>
              </form>
            </div>
          </div>
        </div>
        <app-footer></app-footer>
        <div class="full-page-background" style="background-image: url(/static/img/background/background-2.jpg) "></div>
      </div>
    </div>
    <DashboardLoading />
  </div>
</template>
<script>
  import { Card, Checkbox, Button } from 'src/components/UIComponents';
  import AppNavbar from './Layout/AppNavbar'
  import AppFooter from './Layout/AppFooter'
  import { EventBus } from '@/event-bus.js';
  import DashboardLoading from '@/components/Dashboard/Layout/DashboardLoading.vue';

  export default {
    components: {
      Card,
      AppNavbar,
      AppFooter,
      [Checkbox.name]: Checkbox,
      [Button.name]: Button,
      DashboardLoading
    },
    methods: {
      toggleNavbar() {
        document.body.classList.toggle('nav-open')
      },
      closeMenu() {
        document.body.classList.remove('nav-open')
        document.body.classList.remove('off-canvas-sidebar')
      },
      login() {
        EventBus.$emit("toggleDashboardLoader", "show");
        const vm = this
        this.$validator.validate().then(valid => {
          if (!valid) {
                EventBus.$emit("toggleDashboardLoader", "hide");
                return false
            } else {
                  this.loginError = '';
                vm.$store.dispatch('auth/login', {
                    email: vm.form.email,
                    password: vm.form.password
                })
                .then((response) => {
                  console.log('response from login',response)
                  EventBus.$emit("toggleDashboardLoader", "hide");
                  this.$router.push('admin');
                }).catch((error)=> {
                  console.log('error from login',error);
                  EventBus.$emit("toggleDashboardLoader", "hide");
                  if(error.response && error.response.data.message){
                    this.loginError = error.response.data.message;
                    if(error.response.data.hint){
                      this.loginError += '<br />(Hint: '+error.response.data.hint+')';
                    }
                    return;
                  }
                  console.log('error',error)
                  console.log('error.response',error.response)
                  if(error.response.data.error){
                    if('Already authenticated.' === error.response.data.error){
                      this.$router.push('admin');
                      return false;
                    }
                    return this.loginError = error.response.data.error;
                  }
                  return this.loginError = 'There\'s been an error';
                })
          }
        })
			}
    },
    data() {
      return {
        form: {
          email: '',
          password: ''
        },
        loginError: ''
      }
    },
    beforeDestroy() {
      this.closeMenu()
    }
  }
</script>
<style scoped lang="scss">
  .bg-red {
    background:darkred;
  }
</style>
